import { useEffect, useState } from 'react';

import { Partner } from 'src/modules/designStudio/helpers/Partner';
import { usePartner } from 'src/modules/designStudio/hooks';
import { Mode } from 'src/modules/designStudio/providers';
import { useIsLandscape, useMode } from 'src/shared/hooks';

import { useFullscreenConfig } from './useFullscreenConfig';
import { useShouldCenterToolbar } from './useShouldCenterToolbar';
import { useShouldDisplayToolbar } from './useShouldDisplayToolbar';

interface ToolbarDisplaySettings {
  displayDisabled: boolean;
  displayVersionReset: boolean;
  shouldCenterToolbar: boolean;
  shouldDisplayToolbar: boolean;
  onlyDisplayToolbarInFullscreen: boolean;
  shouldDisplayFullscreenButton: boolean;
}

const useToolbarDisplaySettings = (): ToolbarDisplaySettings => {
  const mode = useMode();
  const partner = usePartner();
  const [isLandscape] = useIsLandscape();

  const [displayVersionReset, setDisplayVersionReset] = useState(
    mode !== Mode.GUEST,
  );
  const [displayDisabled, setDisplayDisabled] = useState(
    partner === Partner.DEFAULT,
  );
  const shouldDisplayToolbar = useShouldDisplayToolbar(mode);
  const shouldCenterToolbar = useShouldCenterToolbar(
    isLandscape,
    displayDisabled,
    displayVersionReset,
  );

  const { shouldDisplayFullscreenButton, onlyDisplayToolbarInFullscreen } =
    useFullscreenConfig();

  useEffect(() => {
    setDisplayVersionReset(mode !== Mode.GUEST);
  }, [mode]);

  useEffect(() => {
    setDisplayDisabled(partner === Partner.DEFAULT);
  }, [partner]);

  return {
    displayDisabled,
    displayVersionReset,
    shouldCenterToolbar,
    shouldDisplayToolbar,
    onlyDisplayToolbarInFullscreen,
    shouldDisplayFullscreenButton,
  };
};

export { useToolbarDisplaySettings };
